import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'status-upload-one',
  templateUrl: './status-upload-one.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryStatusUploadOneComponent implements OnInit {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  innerContent = {
    subTitle:
      'If you have finished uploading digital items, and selecting the items you want to upload from your mobile device, mark this as complete and move to the next step.',
  };

  ngOnInit(): void {
    this.innerContent[
      'title'
    ] = `Mark  <span class="font-bold text-[#25508E]"> Uploads Part 1 </span> for  <span class="font-bold text-[#25508E]"> ${this.data?.path_name} </span> complete?`;
  }

  previousNextStatusEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }
}
